import { IReducerAction } from 'src/interfaces/redux';
import { IPlayerError } from 'src/interfaces/PlayerError';
export * from './playerError.selectors';

export interface IPlayerErrorState {
  error: IPlayerError | null;
}

export const playerErrorInitialState: IPlayerErrorState = {
  error: null,
};

export enum PlayerErrorActionTypes {
  SET_PLAYER_ERROR = 'PLAYER_ERROR/SET_PLAYER_ERROR',
  CLEAR_PLAYER_ERROR = 'PLAYER_ERROR/CLEAR_PLAYER_ERROR',
}

export type PlayerErrorAction = IReducerAction<PlayerErrorActionTypes>;

export default function playerErrorReducer(
  state: IPlayerErrorState = playerErrorInitialState,
  action: PlayerErrorAction
) {
  switch (action.type) {
    case PlayerErrorActionTypes.SET_PLAYER_ERROR:
      return { ...state, error: action.payload };
    case PlayerErrorActionTypes.CLEAR_PLAYER_ERROR:
      return { ...playerErrorInitialState };
    default:
      return state;
  }
}
